import { Taxes } from '../../../member-profile/components/Taxes';

const TaxesPage = () => {
    return <Taxes />;
};

export default TaxesPage;
